<!-- eslint-disable no-tabs -->
<template>
  <div>
    <div class="panel-notification is-scroll"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10"
    >
      <div
        class="list-notification pointer "
        :class="{ 'is-active': isSelectedLog(item.entity_id, item.api_name, item.sub_entity_id) }"
        v-for="(item, index) in data"
        :key="'notification-list-' + index"
        @click="selectItem(index)"
      >

        <i class="icon-list">
          <svgicon name="icon-rejections" :original="true"/>
        </i>
        <div class="list-content">
          <div>
            <p>
              <strong>
                {{item.sub_entity_id}} : {{$t(item.api_name) && $t(item.api_name).toUpperCase()}}
              </strong>
            </p>
            <p>
              {{ $t('INDENT_LR_NUMBER') }} :
              <strong>
                 {{item.entity_id}}  
              </strong>
            </p>
            <p>
              {{ $t('COURIER_PARTNER_STATUS_CODE') }} :
              <strong>
                {{item.mitm_error_status}}
              </strong>
            </p>
          </div>
          <div class="ml-auto text-muted mr-10">
            {{item.updated_at}}
          </div>
        </div>
      </div>
      </div>
      <div v-if="!data.length && isListLoadingCompleted"
      class="status-msg my-sm" size="small" text="top-left" style="width:45%;">
        <div class="status-content">
          <span class="status-inner">
            <img :src="NoData" width="200" height="180" class="img-responsive" alt=""/>
            <p style="width:100px; left:20px;">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
          </span>
        </div>
      </div>
      <div v-if="!isListLoadingCompleted" class="status-msg my-md" style="width:45%;">
        <span>
          <img :src="LoaderCommon" width="240" class="img-responsive" alt=""/>
        </span>
      </div>
  </div>
  </template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';
export default {
  name: 'entity-list',
  props: {
    data: {
      type: Array,
    },
    isListLoadingCompleted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItem: null,
      NoData,
      LoaderCommon,
    };
  },
  computed: {
    isSelectedLog() {
      return ((entityNo, apiName, subEntityNo) => !!(this.selectedItem &&
      (this.selectedItem.entity_no || this.selectedItem.entity_id) === entityNo &&  
      (this.selectedItem.sub_entity_id) === subEntityNo) &&
          !!(this.selectedItem && (this.selectedItem.api_name) === apiName));
    },
  },
  methods: {
    loadMore() {
      this.$emit('load-more');
    },
    selectItem(index) {
      this.selectedItem = this.data[index];
      this.$emit('select-item', this.selectedItem);
    },
  },
};
</script>
<style scoped>
.panel-notification.is-scroll {
    height: calc(100% - 250px) !important;
}
</style>
